import { questionnaireGql } from '../../../gql-gen/questionnaire'

export const REMOVE_MATRIX_ROW = questionnaireGql(/* GraphQL */ `
  mutation removeMatrixRowV2($input: RemoveMatrixRowV2Input!) {
    removeMatrixRowV2(input: $input) {
      ...DraftMatrixRow
    }
  }
`)
